import { LanguageSettings, RestApiSettingsForm, UserInformationForm } from './components';
import { getEmployee, langsTransformData } from './store';
import { GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEE } from '@/common/actions/get';
import { useQuery } from '@apollo/client';
import { Box, Typography } from '@servicepipe/ui-components';
import React from 'react';
import { useParams } from 'react-router-dom';

export const EditUser = () => {
  const { userId } = useParams();

  const { data, loading } = useQuery(GET_PARTNER_CLIENT_ACCOUNT_EMPLOYEE, {
    variables: { id: [Number(userId)] },
    skip: !userId,
  });

  const employee = getEmployee(data);
  const languageData = employee ? langsTransformData([employee])[0] : null;

  if (loading) {
    return (
      <Box>
        <Typography variant="bodyMR">Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box display="flex" direction="column" gap="55px">
      <Box display="flex" width="100%" gap="90px" align="flex-start" wrap="wrap">
        <UserInformationForm employee={employee} userId={Number(userId)} />

        <Box direction="column" gap="20px" width="50%" maxWidth="600px">
          <Typography variant="h6">REST API settings</Typography>
          <RestApiSettingsForm employee={employee} userId={Number(userId)} />
        </Box>
      </Box>

      <LanguageSettings languageData={languageData} userId={Number(userId)} />
    </Box>
  );
};

export default EditUser;
